module.exports = __webpack_public_path__ + "static/combined-05edc56413a515dfba3487b65fdb6791.png";